var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#FFE9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6190_25380)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0703 7.92974C15.6862 7.54572 15.0636 7.54572 14.6796 7.92974L11.9999 10.6094L9.32026 7.92974C8.93624 7.54572 8.31363 7.54572 7.92961 7.92974C7.5456 8.31375 7.5456 8.93636 7.92961 9.32038L10.6093 12.0001L7.92961 14.6797C7.5456 15.0638 7.5456 15.6864 7.92961 16.0704C8.31363 16.4544 8.93624 16.4544 9.32026 16.0704L11.9999 13.3907L14.6796 16.0704C15.0636 16.4544 15.6862 16.4544 16.0703 16.0704C16.4543 15.6864 16.4543 15.0638 16.0703 14.6797L13.3906 12.0001L16.0703 9.32038C16.4543 8.93636 16.4543 8.31375 16.0703 7.92974Z",
    fill: "#F42E33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6190_25380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRejected);
export default __webpack_public_path__ + "static/media/statusRejected.ae71ce77122774d993e8d31f658c674b.svg";
export { ForwardRef as ReactComponent };